import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import type { UpdateClientEmailRequest } from 'src/types/email_notifications';
import axiosInstance from 'src/utils/axios';

const useAddNotificationEmailMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateClientEmailRequest) => {
      await axiosInstance.post(api.addNotificationEmail, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.client.notificationEmails() });
    },
  });
};

export default useAddNotificationEmailMutation;
